import { render, staticRenderFns } from "./NpaVersionBlocks.vue?vue&type=template&id=f245cba2"
import script from "./NpaVersionBlocks.vue?vue&type=script&lang=js"
export * from "./NpaVersionBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports